/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useCallback } from "react";
import { MotivoType } from "models/motivo";
import { TIPO_CARTAO_CONVENIO, TipoCartao } from "models/tipoCartao";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";
import {
  cleanState as cleanMotivoState,
  setMotivoSelecionado,
} from "redux/features/motivo/motivo-slice";
import lock_icon from "../../../../assets/images/padlock.png";
import AppButton from "../../../../components/AppButton/AppButton";
import Endpoints from "services/api/endpoints";
import useApi, { ApiMethod } from "hooks/useApi";
import { setLoading, setTitleLoading } from "redux/ui/loadings-slice";
import { RouteNames } from "../../../../routes/routes";
import { FaCheck } from "react-icons/fa";
import "./BloqueioCartaoEscolhaMotivo.css";
import { useHistory, useLocation } from "react-router";
import { showMessage } from "utils/messages";
import { cleanState } from "redux/features/cliente/cliente-slice";
import Swal from "sweetalert2";
import { getItemLocalStore } from "utils/storeUtils";
import {
  LOCAL_STORE_CLIENTE,
  LOCAL_STORE_ITOKEN,
  LOCAL_STORE_TOKEN_BEARER,
} from "../../../../constants";

/**
 * ? Ao selecionar um motivo de bloqueio do cartão nesta tela, o usuário será solicitado
 * ? a digitar a senha na próxima tela, logo após, selecionar SIM ou NÃO para emitir a
 * ? segunda via.
 */
const BloqueioCartaoEscolhaMotivo = () => {
  const history = useHistory();
  const { state } = useLocation<{ tipoCartaoSelecionado?: TipoCartao }>();
  const tipoCartaoSelecionado = state?.tipoCartaoSelecionado;
  const dispatch = useAppDispatch();
  const {
    motivo: { selecionado },
    cliente: { cliente, cartaoBloqueado },
  } = useAppSelector((state) => state);
  const [motivos, setMotivos] = useState<any>([]);

  const clickVoltar = () => {};

  const handleSelectMotivo = (motivo: MotivoType) => {
    dispatch(setMotivoSelecionado(motivo));
  };

  const { cartaoAtual, cartaoAtualConvenio, dadosLogin } = getItemLocalStore(
    LOCAL_STORE_CLIENTE
  );
  const cartaoSelecionado =
    tipoCartaoSelecionado === TIPO_CARTAO_CONVENIO
      ? cartaoAtualConvenio && {
          ...cartaoAtualConvenio,
          numeroCartao: dadosLogin?.numeroCartaoConvenio,
        }
      : cartaoAtual && {
          ...cartaoAtual,
          numeroCartao: dadosLogin?.numeroCartaoTeucard,
        };

  const getMotivos = useApi<any>(
    Endpoints.autorizador.searchMotivos.replace("PARAM_ORIGIN", "TOTEM"),
    ApiMethod.GET
  );

  const getSelectMotivo = useCallback(async () => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Carregando motivos do bloqueio..."));

    const response = await getMotivos.callApi();

    if (response.status >= 200 && response.status < 300) {
      const options = response.data?.data.filter(
        (e: any) => e.idMotivo !== 11 && e.idMotivo !== 9
      );
      setMotivos(options);

      dispatch(setLoading(false));
    } else {
      dispatch(setLoading(false));
      const { mensagem } = response.data;
      showMessage("warning", "Atenção!", mensagem);
    }
  }, []);

  useEffect(() => {
    dispatch(cleanMotivoState());
    // dispatch(fetchGetMotivos());
    getSelectMotivo();
  }, []);

  //Effect para verificar se a pessoa possue artão para ser bloqueado.
  useEffect(() => {
    if (cartaoBloqueado) {
      showMessage("info", "Cartão", "Você não tem cartão ativo no momento.", {
        timer: 6000,
      });
      dispatch(cleanState());
      localStorage.removeItem(LOCAL_STORE_ITOKEN);
      localStorage.removeItem(LOCAL_STORE_CLIENTE);
      localStorage.removeItem(LOCAL_STORE_TOKEN_BEARER);
      history.push(RouteNames.HOME);
    }
  }, []);

  const handleConfirmarMotivo = (selecionado: MotivoType) => {
    Swal.fire({
      icon: "question",
      text: "Deseja realmente bloquear o teu TeuCard?",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Nao",
      confirmButtonColor: "#33A733",
    }).then((result) => {
      if (result.isConfirmed) {
        fetchBloqueiaCartao(selecionado);
      } else {
        history.push({
          pathname: RouteNames.ATENDIMENTO_HOME,
        });
      }
    });
  };

  const putBloqueiaCartao = useApi<any>(
    Endpoints.autorizador.bloquearCartao,
    ApiMethod.PUT
  );

  const getTokenCartaoByNumero = useApi<any>(
    Endpoints.autorizador.getTokenNumeroCartao,
    ApiMethod.POST,
    {},
    {},
    { usePublicToken: true }
  );

  const fetchBloqueiaCartao = useCallback(async (selecionado: MotivoType) => {
    dispatch(setLoading(true));
    dispatch(
      setTitleLoading("Aguarde enquanto estamos bloqueando o seu cartão.")
    );
    const tokenCartao = await getTokenCartaoByNumero.callApi({
      numeroCartao: cartaoSelecionado?.numeroCartao,
    });
    const payload = {
      idMotivo: selecionado?.idMotivo,
      senha: cliente.senha,
      tokenCartao: tokenCartao.data.tokenCartao,
    };

    const response = await putBloqueiaCartao.callApi(payload);

    if (response.status >= 200 && response.status < 300) {
      history.push({
        pathname: RouteNames.BLOQUEIO_QUER_SEGUNDA_VIA,
        state: { ...cartaoSelecionado, tipoCartaoSelecionado },
      });

      dispatch(setLoading(false));

      if (tokenCartao.status >= 400) {
        dispatch(setLoading(false));
        const { mensagem } = tokenCartao.data;
        showMessage("warning", "Atenção!", mensagem);
        history.push(RouteNames.HOME);
      }
    } else {
      dispatch(setLoading(false));
      const { mensagem } = response.data;
      showMessage("warning", "Atenção!", mensagem);
    }
  }, []);

  return (
    <div className="bloqueio-motivo-escolha-content">
      <h1 id="bloqueio-motivo-escolha-title">Bloqueio do Cartão</h1>

      <h3 id="bloqueio-motivo-escolha-description">
        Selecione o motivo do Bloqueio do Cartão:
      </h3>

      <div className="bloqueio-motivo-escolha-buttons">
        {motivos.map((motivo: any) => (
          <button
            className={`normal ${
              selecionado?.idMotivo === motivo.idMotivo ? "withIcon" : ""
            }`}
            key={`motivo-${motivo.idMotivo}`}
            onClick={() => handleSelectMotivo(motivo)}
          >
            {selecionado?.idMotivo === motivo.idMotivo && (
              <FaCheck className="icon" />
            )}
            {motivo.descricao}
          </button>
        ))}
      </div>
      {/* Retorna para a tela anterior de acordo com o fluxo */}
      <div id="escolher-motivo-btn-voltar">
        <AppButton
          content="Voltar"
          route={RouteNames.HOME}
          outlined={true}
          click={clickVoltar}
        />

        {selecionado && (
          <button
            className="normal confirm"
            onClick={() => handleConfirmarMotivo(selecionado)}
            style={{ width: "330px", marginLeft: "15px" }}
          >
            Confirmar motivo{" "}
          </button>
        )}
      </div>

      <img id="bloqueio-motivo-escolha-padlock" src={lock_icon} alt="" />
    </div>
  );
};

export default BloqueioCartaoEscolhaMotivo;
